import { Inject, Injectable } from '@angular/core';
import { IStringAnyMap } from '../types';
import { BOOX_MATOMO, BooxMatomoToken } from '../token';

declare let _paq: any;
declare const window: any;

@Injectable({
  providedIn: 'root'
})
export class MatomoService {

  constructor(
    @Inject(BOOX_MATOMO) private matomo: BooxMatomoToken,
  ) {
    this.initMatomo();
  }

  private initMatomo() {

    window._paq = window._paq || [];

    if(!this.matomo) { return; }

    // Matomo id and url
    let matomoId = this.matomo.id;
    let matomoUrl = this.matomo.url;
    if(!matomoId || !matomoUrl) { return; }

    const u = matomoUrl;
    
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    _paq.push(['setTrackerUrl', u + 'matomo.php']);
    _paq.push(['setSiteId', matomoId]);
    const d = document;
    const g = d.createElement('script');
    const s = d.getElementsByTagName('script')[0];
    g.async = true;
    g.src = u + 'matomo.js';
    if(!!s && s.parentNode) {
      s.parentNode.insertBefore(g, s);
    }
  }

  trackPageView(url: string): void {
    _paq.push(['setCustomUrl', url]);
    _paq.push(['trackPageView']);
  }

  /**
   * Track a custom event
   * @param category - Event category (e.g., 'Video')
   * @param action - Event action (e.g., 'Play')
   * @param name - Event name (optional)
   * @param value - Event value (optional)
   */
  trackEvent(category: string, action: string, name?: string, value?: number): void {
    if (window._paq) {
      _paq.push(['trackEvent', category, action, name || '', value || 0]);
    }
  }

  /**
   * Track a search query
   * @param keyword - The search keyword entered by the user
   * @param category - The search category (optional)
   * @param resultCount - The number of search results (optional)
   */
  trackSearch(keyword: string, category?: string, resultCount?: number): void {
    if (window._paq) {
      window._paq.push(['trackSiteSearch', keyword, category || '', resultCount || 0]);
    }
  }
}
